'use strict';

import defaultTemplate from '../../core/default.html';
import billingListTemplate from './billing.list.html';
import billingPlanTemplate from './billing.plan.html';

import Billing from './billing.ctrl';

function BillingRouter($urlRouterProvider, $stateProvider) {
  $stateProvider
    .state('main.billing', {
      url: '/billing',
      template: defaultTemplate,
      resolve: {}
    })
    .state('main.billing.list', {
      url: '/list?:from&:organizationId',
      template: billingListTemplate,
      controller: 'BillingListController as vm',
      resolve: {
        permission: ($q, PermissionsService) => {
          return PermissionsService.canIConfigureBilling()
            ? $q.resolve()
            : $q.reject('Route permission check failed: main.billing.list');
        }
      }
    })
    .state('main.billing.plan', {
      url: '/plan?:from&:organizationId',
      template: billingPlanTemplate,
      controller: 'BillingPlanController as vm',
      resolve: {
        permission: ($q, utils, PermissionsService) => {
          const SELECTED_ORG_LOCAL_STORAGE_KEY = 'Selected-Org';
          let selectedOrg = utils.getStorageItem(SELECTED_ORG_LOCAL_STORAGE_KEY);
          return PermissionsService.canIViewBills(selectedOrg)
            ? $q.resolve()
            : $q.reject('Route permission check failed: main.billing.plan');
        }
      }
    });
}

export default angular
  .module('billing.router', [
    Billing
  ])
  .config(BillingRouter)
  .name;
